import { get } from 'lodash'
import { useQuery } from 'react-query'
import useApi from '../use-api'
import useCacheKeys from '../use-cache-keys'
import currentGradYear from '../../utilities/current-grad-year'
import isStudent from '../../utilities/is-student'

const useStudents = ({
    offset = 0,
    limit = 30,
    search,
}) => {
    const cacheKeys = useCacheKeys()
    const { api, url, endpoints } = useApi()
    const gradYearStart = currentGradYear
    const gradYearEnd = gradYearStart + 4

    const isActiveGradYear = (gradYear) => gradYear >= gradYearStart && gradYear <= gradYearEnd
    const isActiveStudent = (s) => isStudent(s) && isActiveGradYear(parseInt(s.gradYear))

    const filters = {
        r: 's',
        offset,
        limit,
        s: search,
    }
    const { data, isLoading } = useQuery(
        [cacheKeys.USERS, filters],
        () => api.get(url(endpoints.users, {}, filters))
    )

    const students = get(data, 'items', []).filter(isActiveStudent)

    return {
        students,
        isLoading
    }
}

export default useStudents
